import { DateTime } from "luxon"

import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPI, KPIGroupRequest, KPIRequest } from "@/types/kpiTypes.ts"

export const getIncentiveGauge = async (asOf: Date, kpi: KPIRequest): Promise<KPI> => {
  const startDate = DateTime.fromJSDate(asOf).startOf("month").toISODate() || ""
  const endDate = DateTime.fromJSDate(asOf).toISODate() || ""

  const request: KPIGroupRequest = {
    startDate,
    endDate,
    kpis: [kpi],
    aggType: "Daily",
  }

  const res = await getKPIRequest(request)

  return res[0]
}
